import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=205f3502&scoped=true"
import script from "./message-text.vue?vue&type=script&lang=ts"
export * from "./message-text.vue?vue&type=script&lang=ts"
import style0 from "./message-text.vue?vue&type=style&index=0&id=205f3502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f3502",
  null
  
)

export default component.exports